import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const PrimaryMessageHeaderContentWrapper = styled.div.withConfig({
  displayName: "PrimaryMessageHeaderContent__PrimaryMessageHeaderContentWrapper",
  componentId: "o8x5wp-0"
})(["margin-left:1px;min-width:0;"]);
export default class PrimaryMessageHeaderContent extends PureComponent {
  render() {
    const {
      children,
      className
    } = this.props;
    return /*#__PURE__*/_jsx(PrimaryMessageHeaderContentWrapper, {
      className: className,
      "data-test-id": "primary-message-header-content-wrapper",
      children: children
    });
  }
}
PrimaryMessageHeaderContent.displayName = 'PrimaryMessageHeaderContent';
PrimaryMessageHeaderContent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};